export default __webpack_public_path__ + "static/lovers-deep-78b87c61907b1b66471c57bcc934556f.jpg";